export enum EditArticleActionTypes {
  EDIT_ARTICLE_REQUEST = '[EditArticle]  EDIT_ARTICLE_REQUEST',
  EDIT_ARTICLE_SUCCESS = '[EditArticle] EDIT_ARTICLE_SUCCESS',
  EDIT_ARTICLE_ERROR = '[EditArticle] EDIT_ARTICLE_ERROR',

  GET_ARTICLE_REQUEST = '[EditArticle]  GET_ARTICLE_REQUEST',
  GET_ARTICLE_SUCCESS = '[EditArticle] GET_ARTICLE_SUCCESS',
  GET_ARTICLE_ERROR = '[EditArticle] GET_ARTICLE_ERROR',
}
